import ListCreditScoreDistributionBox from './ListCreditScoreDistributionBox'

export default ListCreditScoreDistributionBox
